// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const ReimbursedPercentIndicator = t.struct({
    red: t.maybe(t.Number),
    yellow: t.maybe(t.Number)
}, {
    name: 'ReimbursedPercentIndicator',
    strict: true
});

export const getDefaultState = () => new ReimbursedPercentIndicator({
    red: null,
    yellow: null
});

export default ReimbursedPercentIndicator;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/reimbursed-percent-indicator.js